export const mapContextToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfDevice: item?.total_device,
  }));

  return result;
};

export const contextColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "type", label: "Type", align: "center" },
  { key: "numOfDevice", label: "Num Of Device", align: "center" },
];
